<template>
  
  <v-container>

    <v-layout
      text-xs-center
      row wrap
      mt-5
      justify-center
    >
      <v-flex xs4 sm3 md2>
        <v-img src="https://firebasestorage.googleapis.com/v0/b/potsdam-billard-festival.appspot.com/o/svmb-logo.png?alt=media&token=5ec21b64-3446-4112-b59b-e4137a862221"/>
      </v-flex>
      <v-flex xs12>
        <h1>Der SV Motor Babelsberg präsentiert</h1>
      </v-flex>
      <v-flex xs12 sm6 pa-2 mt-5 fill-height
          v-for="(tournament, i) in tournaments" :key="i">
        <v-card dark color="secondary" :to="'/tournament/' + tournament.link">
          <v-card-text>
            <h2>{{ tournament.name }}</h2>
            <p class="description" v-html="tournament.description" />
          </v-card-text>    
        </v-card>
      </v-flex>
      
    </v-layout>
    
  </v-container>

</template>

<style>
  .description {
    color: #ccc;
    margin-top: 10px;
  }
</style>

<script>
  import Repo from '../data/repository.js'

  export default {
    data: function() {
      return {
        tournaments: [{
          name: "Potsdam Open 2019",
          link: "potsdam-open-2019",
          description: `
            Die Potsdam Open ist ein Multiball-Turnier mit max. 64 Teilnehmern. Es ist offen für alle und findet vom <b>23.05.</b> bis <b>26.05.2019</b> statt.
          `
        }, {
          name: "Potsdamer Billard Festival 2019",
          link: "potsdam-billard-festival-2019",
          description: `
            Deutschlands größtes Billard-Turnier für Freizeitspieler vom <b>30.05.</b> - <b>02.06.2019</b>. Keine Vereinsspieler!!! 
          `
        }]
      }
    },
    created: function() {
      this.$vuetify.theme.tournament1 = "#000";
      this.$vuetify.theme.tournament2 = "#333";  
    }
  }
</script>